import { useState } from 'react';
import debounce from 'lodash/debounce';
import { usePostAsyncBackgroundMessage } from '../../../iframe/useBackgroundApp';
import { DEFAULT_OPTIONS } from '../../../constants/defaultFormOptions';
import { ProxyMessages } from '../../../iframe/integratedMessages';
export default function useForms() {
    const proxy = usePostAsyncBackgroundMessage();
    const [formApiError, setFormApiError] = useState(null);
    const search = debounce((search, callback) => {
        return proxy({
            key: ProxyMessages.FetchForms,
            payload: {
                search,
            },
        })
            .then(forms => {
            callback([
                ...forms.map((form) => ({
                    label: form.name,
                    value: form.guid,
                    embedVersion: form.embedVersion,
                })),
                DEFAULT_OPTIONS,
            ]);
        })
            .catch(error => {
            setFormApiError(error);
        });
    }, 300, { trailing: true });
    return {
        search,
        formApiError,
        reset: () => setFormApiError(null),
    };
}
